import api from './apiClient';

export const verifyAccess = async (referer, nextPage) => {
  try {
    const response = await api.post(
      '/auth/verify',
      {
        referer,
        nextPage: nextPage.route,
      },
      {
        withCredentials: true, // Enable sending cookies with cross-origin requests
      }
    );

    return {
      isAllowed: true,
      currentLevel: response.data.currentLevel,
    };
  } catch (error) {
    return {
      isAllowed: false,
      redirectTo: error.response?.data?.redirectTo || '/case',
      error: error.response?.data?.message || 'Authentication failed',
    };
  }
};
